export default {
  token: (state) => state.token,
  originalToken: (state) => state.originalToken,
  authStatus: (state) => state.status,
  user: (state) => state.user,
  userId: (state) => state.user.id,
  access: (state) => state.access,
  primaryScopeIds: (state) => state.primaryScopeIds,
  primaryTenantIds: (state) => state.primaryTenantIds,
  tenantId: (state) => state.tenantId,
};
